import request from '@/auth/jwt/request'

/**
 * @description 线索客户 -- 线索客户列表
 * @param {Object} param params {Object} 传值参数
 */
 export const customerListApi = params => { return request('clue-customer/list', 'get', params) }